export default __webpack_public_path__ + "static/1-c7ff3ab113133529116458da062355c6.png";